module.exports = __webpack_public_path__ + "icons8-email-64.png?af231fa26932b36ab7427e4806ed6ce1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons8-email-64.png
// module id = 17
// module chunks = 0